import { useRef } from 'react';

/** Drag handle on a pane's left edge (dragging left widens it); double-click goes back to `initial`. */
export function PaneResizer({ width, min, max, initial, onResize, onDone }: { width: number; min: number; max: number; initial: number; onResize: (w: number) => void; onDone: (w: number) => void }) {
  const drag = useRef<{ x: number; w: number; id: number } | null>(null);
  const clamp = (w: number) => Math.round(Math.max(min, Math.min(max, w)));
  const end = (e: React.PointerEvent) => {
    const g = drag.current;
    if (!g || g.id !== e.pointerId) return;
    drag.current = null;
    onDone(clamp(g.w + g.x - e.clientX));
  };
  return (
    <div
      className="te-resizer"
      title="Drag to resize (double-click: default width)"
      onPointerDown={(e) => {
        e.preventDefault();
        e.currentTarget.setPointerCapture(e.pointerId);
        drag.current = { x: e.clientX, w: width, id: e.pointerId };
      }}
      onPointerMove={(e) => {
        const g = drag.current;
        if (g && g.id === e.pointerId) onResize(clamp(g.w + g.x - e.clientX));
      }}
      onPointerUp={end}
      onPointerCancel={end}
      onDoubleClick={() => onDone(initial)}
    />
  );
}
